import React from 'react';
import { useIntl } from 'react-intl';

import {
  getCheckpointCount,
  GetCheckpointsParams,
  isGetCheckpointCountSuccess
} from '../../checkpoints/actions';
import { useAxiosDispatch } from '../../middleware/axios';
import { messages } from '../Dashboard.translations';
import DashboardItem, { DashboardItemResult } from '../DashboardItem';

export const UnassignedCheckpoints = ( ) => {
  const {formatMessage} = useIntl();
  const dispatch = useAxiosDispatch( );

  const params: GetCheckpointsParams = {
    locationCode: ''
  };
  const headerText = formatMessage(messages['dashboard.unassignedcheckpoints.header']);
  const bodyText = formatMessage(messages['dashboard.unassignedcheckpoints.body']);
  const getUnassignedCount: () => Promise<DashboardItemResult> = async () => {
    const result = await dispatch(getCheckpointCount(params));
    if (!isGetCheckpointCountSuccess(result)) {
      throw new Error('ServiceError');
    }
    const checkpointCount = result.payload.data || 0;
    const response: DashboardItemResult = {
      isResolved: result.payload.data === 0,
      result: checkpointCount.toString()
    };
    return response;
  };

  return (
      <DashboardItem
        onLoad={getUnassignedCount}
        headerText={headerText}
        bodyText={bodyText}
        resolveLink="/checkpoints"
      />
  );
};
